<h1 mat-dialog-title>
  <app-draggable-dialog-handle/>
  Editing Purchase Order &nbsp;<span class="manufacturer-names">{{ data.purchaseOrder.manufacturerNames }}</span> <span
  class="hint">{{ data.purchaseOrder.name }}</span>
</h1>
<div mat-dialog-content>
  <form (ngSubmit)="onSubmit()" [formGroup]="editForm" class="edit-purchase-order-form">
    <mat-form-field class="name">
      <mat-label>Purchase Order Number</mat-label>
      <input formControlName="name" matInput placeholder="Ex. SONUS-202509185" type="text">
      <mat-error *ngIf="editForm.controls.name.hasError('required')">
        field <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <div class="row">
      <mat-form-field class="no-bottom sales-order-confirmation-number">
        <mat-label>Sales Order Confirmation Number</mat-label>
        <input formControlName="salesOrderConfirmationNumber" matInput placeholder="Ex. PN127757-3"
               type="text">
      </mat-form-field>
      <mat-form-field appearance="fill" class="no-bottom sales-order-confirmation-date date">
        <mat-label>SOC Date</mat-label>
        <input
          #salesOrderConfirmationDate="bsDatepicker"
          (bsValueChange)="datePickerValueChange($event, 'salesOrderConfirmationDate')"
          bsDatepicker
          formControlName="salesOrderConfirmationDate"
          matInput>
        <mat-datepicker-toggle (click)="salesOrderConfirmationDate.toggle()"
                               [class.mat-datepicker-toggle-active]="salesOrderConfirmationDate.isOpen"
                               matIconSuffix></mat-datepicker-toggle>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="fill" class="no-bottom estimated-ship-by-date date">
        <mat-label>Estimated Ship By Date</mat-label>
        <input
          #estimatedShipByDate="bsDatepicker"
          (bsValueChange)="datePickerValueChange($event, 'estimatedShipByDate')"
          bsDatepicker
          formControlName="estimatedShipByDate"
          matInput>
        <mat-datepicker-toggle (click)="estimatedShipByDate.toggle()"
                               [class.mat-datepicker-toggle-active]="estimatedShipByDate.isOpen"
                               matIconSuffix></mat-datepicker-toggle>
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button (click)="onCancelClick()" [color]="editForm.dirty ? 'warn' : ''" mat-button>Cancel</button>
  <button (click)="onPrimaryClick()" [disabled]="editForm.pristine || !editForm.valid" color="primary"
          mat-raised-button>Edit
  </button>
  <mat-error *ngIf="apiError" class="api-error">
    {{ apiError }}
  </mat-error>
</div>
